export const CONFIG = {
  // BASE_URL: "http://localhost:3000/v0/",
  BASE_URL:"https://8pkt01mcf6.execute-api.us-east-1.amazonaws.com/v0/",
  GENERATE_OTP: "account/devices/generate-otp",
  DEVICE_LIST: "account/devices",
  VALIDATE_OTP:"account/devices/validate-otp",
  PURCHASE_CONFIRM:"app/transaction/update",
  SEND_INVITATION:"auth/invite"
};